// extracted by mini-css-extract-plugin
module.exports = {"successText":"End_successText__qpDbZ","deviceSummaryContainer":"End_deviceSummaryContainer__96z8b","deviceSummary":"End_deviceSummary__3heFI","icon":"End_icon__3bWp8"};